import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Empty, Spin } from 'antd';
import { Table } from 'semantic-ui-react';
import { withPopup } from '../../lib/popup';
import { Popup } from '../../lib/custom-ui';
import api from '../../api';
import moment from 'moment';

const PayActionsPopup = React.memo(({ id }) => {
  const [list, setList] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  useEffect(() => {
    setLoading(true);
    api
      .getPayActions(id)
      .then((res) => {
        setList(res.items);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);
  return (
    <>
      <Popup.Header wide>操作记录</Popup.Header>
      <Popup.Content style={{ maxHeight: '400px', overflow: 'auto' }}>
        <Spin size="large" tip="加载中..." spinning={loading}>
          <div style={{ minHeight: 200 }}>
            {(loading || list.length) ? (
                <Table celled unstackable fixed sortable>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>原金额</Table.HeaderCell>
                      <Table.HeaderCell>修改金额</Table.HeaderCell>
                      <Table.HeaderCell>修改时间</Table.HeaderCell>
                      <Table.HeaderCell>修改人</Table.HeaderCell>
                      <Table.HeaderCell>备注</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {list.map((item) => (
                      <Table.Row key={item.id}>
                        <Table.Cell>{item.data.original}</Table.Cell>
                        <Table.Cell>{item.data.value}</Table.Cell>
                        <Table.Cell>
                          {item.createdAt && moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                        </Table.Cell>
                        <Table.Cell>{item.userId.name}</Table.Cell>
                        <Table.Cell>{item.data.remark || '-'}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                  <Empty description="暂无数据" />
                </div>
              )}
          </div>
        </Spin>
      </Popup.Content>
    </>
  );
});

PayActionsPopup.propTypes = {
  id: PropTypes.string.isRequired,
};
export default withPopup(PayActionsPopup, {
  position: 'bottom right',
  style: {
    maxWidth: '600px',
    width: '100%',
  },
});
